export var AlertAggregationStatus;
(function (AlertAggregationStatus) {
    AlertAggregationStatus["Pending"] = "pending";
    AlertAggregationStatus["Running"] = "running";
    AlertAggregationStatus["Broken"] = "broken";
})(AlertAggregationStatus || (AlertAggregationStatus = {}));
export var UserAlertStatus;
(function (UserAlertStatus) {
    UserAlertStatus["Triggered"] = "triggered";
    UserAlertStatus["NotTriggered"] = "not-triggered";
})(UserAlertStatus || (UserAlertStatus = {}));
export var AlertContextErrorField;
(function (AlertContextErrorField) {
    AlertContextErrorField["DeletedGoal"] = "deleted-goal";
    AlertContextErrorField["DeletedZone"] = "deleted-zone";
    AlertContextErrorField["DeletedZoning"] = "deleted-zoning";
    AlertContextErrorField["DeletedSegment"] = "deleted-segment";
    AlertContextErrorField["DeletedPage"] = "deleted-page";
    AlertContextErrorField["DeletedMapping"] = "deleted-mapping";
    AlertContextErrorField["DeletedMappingOrPage"] = "deleted-mapping-or-page";
    AlertContextErrorField["DeletedZoningOrZone"] = "deleted-zoning-or-zone";
    AlertContextErrorField["Invalid"] = "invalid";
})(AlertContextErrorField || (AlertContextErrorField = {}));
//# sourceMappingURL=status.js.map